document.addEventListener("DOMContentLoaded", function () {
  var larguraDaTela = window.innerWidth;
  const buttonReturnTop = document.querySelectorAll(".button-return-top");

  if(larguraDaTela < 600){
    const buttonsOpenOrCloseAccordion = document.querySelectorAll(".footer-category-content");
  function OpenOrCloseAccordion(buttons, elementButton) {
    buttons.forEach((element) => {
      if (element.id === elementButton.id) {
        console.log(element.id , elementButton.id)
        console.log(element.children)
        if(element.children[1].classList.contains("AccordionActive")){
          element.children[1].classList.remove("AccordionActive");
          element.children[0].children[1].innerHTML = " + ";

        }else{
          element.children[1].classList.add("AccordionActive");
          element.children[0].children[1].innerHTML = " - ";
        }
      }else{
        element.children[1].classList.remove("AccordionActive");
        element.children[0].children[1].innerHTML = " + ";
      }


    });
  }
  buttonsOpenOrCloseAccordion.forEach((element) => {
    element.addEventListener("click", () => {
      OpenOrCloseAccordion(buttonsOpenOrCloseAccordion, element);
    });
  });
  }

  function scrollToTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth' // 'smooth' para rolar suavemente ou 'auto' para rolar instantaneamente
    });
}
buttonReturnTop.forEach((element) => {
  element.addEventListener("click", () => scrollToTop());
  });

})
